import { render } from "./create.vue?vue&type=template&id=428255ce"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/vvg/forum/resources/vue/topic/create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "428255ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('428255ce', __exports__)) {
    console.log('reload')
    api.reload('428255ce', __exports__)
  }
  
  module.hot.accept("./create.vue?vue&type=template&id=428255ce", () => {
    console.log('re-render')
    api.rerender('428255ce', render)
  })

}


export default __exports__